<template>
  <div id="create">
    <v-container fluid id="anpr-listing-view" class="px-2">
      <v-card elevation="4" color="#EFEBE9" class="px-3 pb-1">
        <v-form v-model="valid">
          <v-row>
            <v-col cols="6" md="2">
              <vdate
                label="From Date"
                :rules="reqRules"
                required
                v-model="fromDate"
              >
              </vdate>
            </v-col>
            <v-col cols="6" md="2">
              <vdate
                label="To Date"
                :rules="reqRules"
                required
                v-model="toDate"
              >
              </vdate>
            </v-col>
            <v-col cols="6" md="1">
              <v-btn
                dense
                color="primary"
                @click="showData"
                block
                :disabled="!valid"
                :loading="tableLoading"
                rounded
                x-large
              >
                <v-icon> mdi-database-search </v-icon>
                Search
              </v-btn>
            </v-col>
            <v-col cols="6" md="7">
              <v-row dense v-for="item in legendData" :key="item.legendName">
                <v-col cols="4" md="10"> </v-col>
                <v-col cols="8" md="2">
                  <v-sheet
                    style="display: inline-block;"
                    :color="item.rowcolor"
                    elevation="1"
                    height="10"
                    width="20"
                  ></v-sheet>

                  <span style="display: inline-block; margin-left: 10px">{{
                    item.legendName
                  }}</span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
      <v-card elevation="4" color="#EFEBE9" class="px-3 my-5">
        <v-row>
          <v-col cols="12">
            <v-tabs
              v-model="tab"
              background-color="warning"
              dark
              icons-and-text
              @change="setChange"
            >
              <v-tabs-slider></v-tabs-slider>

              <v-tab >
                Subjectwise
                <v-icon>mdi-exclamation-thick</v-icon>
              </v-tab>

              <v-tab >
                Monthwise
                <v-icon>mdi-sticker-check-outline</v-icon>
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab" touchless >
              <v-tab-item>
                <v-data-table
                  :mobile-breakpoint="mobilebreakpoint"
                  :headers="headers"
                  :items="listingData"
                  :items-per-page="-1"
                  :search="search1"
                  class="elevation-4 mt-2"
                  :loading="tableLoading"
                  loading-text="Loading... Please wait"
                  group-by="suB_NAME"
                  :item-class="row_classes"
                >
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-text-field
                        v-model="search1"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field>
                      <v-spacer></v-spacer>

                      <v-btn @click="toggleAll()" fab small color="primary"
                        ><v-icon v-if="!isExpanded">mdi-expand-all</v-icon
                        ><v-icon v-if="isExpanded"
                          >mdi-collapse-all</v-icon
                        ></v-btn
                      >
                    </v-toolbar>
                  </template>
                  <template v-slot:item.lcT_DT="{ item }">
                    <span>{{ formatDate(item.lcT_DT, "DD-MMM-YY") }}</span>
                  </template>
                  <template
                    v-slot:group.header="{ group, items, isOpen, toggle }"
                  >
                    <td colspan="2">
                      <v-btn
                        @click="toggle"
                        small
                        icon
                        :ref="group"
                        :data-open="isOpen"
                      >
                        <v-icon v-if="isOpen">mdi-chevron-up</v-icon>
                        <v-icon v-else>mdi-chevron-down</v-icon>
                      </v-btn>
                      Subject : {{ group }}
                    </td>
                    <td style="text-align: right;">
                      {{ sumSubField("tc", group) }}
                    </td>
                    <td style="text-align: right;">
                      {{ sumSubField("p", group) }}
                    </td>
                    <td style="text-align: right;">
                      {{ sumSubField("a", group) }}
                    </td>
                    <td style="text-align: right;">
                      {{ sumSubField("l", group) }}
                    </td>
                    <td style="text-align: right;">
                      {{ sumSubField("e", group) }}
                    </td>
                  </template>

                  <template slot="body.append">
                    <td colspan="2" class="py-3 font-weight-black total">
                      <span>Total</span>
                    </td>
                    <td class="py-3 font-weight-black total">
                      {{ sumTotal("tc") }}
                    </td>
                    <td class="py-3 font-weight-black total">
                      {{ sumTotal("p") }}
                    </td>
                    <td class="py-3 font-weight-black total">
                      {{ sumTotal("a") }}
                    </td>
                    <td class="py-3 font-weight-black total">
                      {{ sumTotal("l") }}
                    </td>
                    <td class="py-3 font-weight-black total">
                      {{ sumTotal("e") }}
                    </td>
                  </template>
                </v-data-table>
              </v-tab-item>
              <v-tab-item touchless>
                <v-data-table
                  :mobile-breakpoint="mobilebreakpoint"
                  :headers="headers"
                  :items="listingData"
                  :items-per-page="-1"
                  :search="search2"
                  class="elevation-4 mt-2"
                  :loading="tableLoading"
                  loading-text="Loading... Please wait"
                  group-by="monthNo"
                  group-desc
                  :item-class="row_classes"
                >
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-text-field
                        v-model="search2"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field>
                      <v-spacer></v-spacer>

                      <v-btn @click="toggleAll()" fab small color="primary"
                        ><v-icon v-if="!isExpanded">mdi-expand-all</v-icon
                        ><v-icon v-if="isExpanded"
                          >mdi-collapse-all</v-icon
                        ></v-btn
                      >
                    </v-toolbar>
                  </template>
                  <template v-slot:item.lcT_DT="{ item }">
                    <span>{{ formatDate(item.lcT_DT, "DD-MMM-YY") }}</span>
                  </template>
                  <template
                    v-slot:group.header="{ group, items, isOpen, toggle }"
                  >
                    <td colspan="2">
                      <v-btn
                        @click="toggle"
                        small
                        icon
                        :ref="group"
                        :data-open="isOpen"
                      >
                        <v-icon v-if="isOpen">mdi-chevron-up</v-icon>
                        <v-icon v-else>mdi-chevron-down</v-icon>
                      </v-btn>
                      Month : {{ items[0].mname }}
                    </td>
                    <td style="text-align: right;">
                      {{ sumMnthField("tc", group) }}
                    </td>
                    <td style="text-align: right;">
                      {{ sumMnthField("p", group) }}
                    </td>
                    <td style="text-align: right;">
                      {{ sumMnthField("a", group) }}
                    </td>
                    <td style="text-align: right;">
                      {{ sumMnthField("l", group) }}
                    </td>
                    <td style="text-align: right;">
                      {{ sumMnthField("e", group) }}
                    </td>
                  </template>

                  <template slot="body.append">
                    <td colspan="2" class="py-3 font-weight-black total">
                      <span>Total</span>
                    </td>
                    <td class="py-3 font-weight-black total">
                      {{ sumTotal("tc") }}
                    </td>
                    <td class="py-3 font-weight-black total">
                      {{ sumTotal("p") }}
                    </td>
                    <td class="py-3 font-weight-black total">
                      {{ sumTotal("a") }}
                    </td>
                    <td class="py-3 font-weight-black total">
                      {{ sumTotal("l") }}
                    </td>
                    <td class="py-3 font-weight-black total">
                      {{ sumTotal("e") }}
                    </td>
                  </template>
                </v-data-table>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </v-card>

      <vconfirm
        :confirmOption="confirmBox"
        @isConfirm="isConfirm"
        :dialogConfirm="dialogConfirm"
        :confirmLoading="confirmLoading"
      >
      </vconfirm>
    </v-container>
  </div>
</template>
<style scoped>
.v-data-table {
  max-width: 100%;
}
.total {
  background-color: lightgray;
  text-align: right;
  padding-right: 1em;
}

.subtotal {
  background-color: yellow;
}
</style>
<script>
import axios from "axios";
import { get, sync } from "vuex-pathify";
import vdate from "@/components/v-date";
import { formatDate } from "../util/helpers";
import vconfirm from "@/components/v-confirm";

import moment from "moment";
import { showSnackbar } from "../util/globalActions";
export default {
  name: "AttendanceDetailsView",
  components: { vdate, vconfirm },

  data: () => ({
    isExpanded: false,
    tab: null,
    validEdit: false,
    switchmobilebreakpoint: false,
    mobilebreakpoint: "200",
    confirmBox: {
      message: "",
      okCaption: "OK",
      cancelCaption: "Cancel",
      data: "",
    },
    dialogConfirm: false,
    confirmLoading: false,
    isConfirm: false,
    width: 700,
    tableLoading: false,
    loadingprofessor: false,
    valid: false,
    modal: false,
    fromDate: null,
    toDate: null,
    search1: "",
    search2: "",
    listingData: [],
    legendData: [],
    message: "",
    professors: [],
    snackbar: false,
    reqRules: [(v) => !!v || "Field is required"],
    professor_id: null,
    headers: [],
    headers1: [],
    headers2: [],
    expanded: [],
    expandedmonth: [],
  }),
  created() {
    this.headers = [];
    this.headers1 = [];
    if (this.userid.charAt(0) === "U") {
      this.headers.push({
        text: "Date",
        value: "lcT_DT",
        width: "120px",
      });
      this.headers.push({
        value: "tS_TIMESLOT",
        text: "Time",
        width: "150px",
      });
      this.headers.push({
        value: "tc",
        text: "Total",
        width: "100px",
        align: "right",
      });
      this.headers.push({
        value: "p",
        text: "Present",
        width: "100px",
        align: "right",
      });
      this.headers.push({
        value: "a",
        text: "Absent",
        width: "100px",
        align: "right",
      });
      this.headers.push({
        text: "Late",
        value: "l",
        width: "100px",
        align: "right",
      });
      this.headers.push({
        text: "Excused",
        value: "e",
        width: "100px",
        align: "right",
      });
    } else {
      this.headers.push({
        text: "Date",
        value: "lcT_DT",
        width: "120px",
      });
      this.headers.push({
        value: "tS_TIMESLOT",
        text: "Time",
        width: "150px",
      });
      this.headers.push({
        value: "tc",
        text: "Total",
        width: "100px",
        align: "right",
      });
      this.headers.push({
        value: "p",
        text: "Present",
        width: "100px",
        align: "right",
      });
      this.headers.push({
        value: "a",
        text: "Absent",
        width: "100px",
        align: "right",
      });
      this.headers.push({
        text: "Late",
        value: "l",
        width: "100px",
        align: "right",
      });
      this.headers.push({
        text: "Excused",
        value: "e",
        width: "100px",
        align: "right",
      });
    }
    if (!this.selectedfromdate) {
      this.getDefaultDate();
    } else {
      this.fromDate = new Date(this.selectedfromdate);
      this.toDate = new Date(this.selectedtodate);
      this.showData();
    }
  },
  mounted() {},
  updated() {
    this.closeAll();
    //this.closeAll1();
  },

  computed: {
    apiUrl: get("app/apiUrl"),
    userid: get("user/id"),
    menuid: get("user/menuid"),
    selectedfromdate: sync("app/attendancefromdate"),
    calenderselecteddate: get("app/calenderselecteddate"),
    fromDashboard: sync("app/fromDashboard"),
    selectedtodate: sync("app/attendancetodate"),
    selecteduserid: get("app/selecteduserid"),
  },
  watch: {
    switchmobilebreakpoint: function(value) {
      if (value === true) this.mobilebreakpoint = "600";
      else this.mobilebreakpoint = "200";
    },
  },
  methods: {
    formatDate,
    getParameter() {
      const self = this;
      const fromDate = new Date(self.fromDate).toJSON();
      const toDate = new Date(self.toDate).toJSON();
      const data = {
        fromDate: fromDate,
        uptoDate: toDate,
      };
      return data;
    },
    getDefaultDate() {
      const self = this;
      axios({
        url: self.apiUrl + "api/Common/getAcademicToday",

        method: "GET",
        responseType: "json",
      }).then(function(response) {
        self.fromDate = moment(new Date(response.data.fromDate)).format(
          "YYYY-MM-DD"
        );
        self.toDate = moment(new Date(response.data.toDate)).format(
          "YYYY-MM-DD"
        );

        self.showData();
      });
    },

    showData() {
      const self = this;
      self.selectedfromdate = self.fromDate;
      self.selectedtodate = self.toDate;

      self.tableLoading = true;
      const data = self.getParameter();

      axios({
        url: self.apiUrl + "api/Attendance/attendancedetails",
        data: data,
        method: "POST",
        responseType: "json",
      })
        .then(function(res) {
          self.listingData = res.data.data;
          self.legendData = res.data.legends;
          self.tableLoading = false;
          self.hiddenPDF = false;
        })
        .catch(function(err) {
          self.hiddenPDF = true;
          self.tableLoading = false;
          self.message = err.status;

          showSnackbar({ message: "Data not found!" });
        });
    },
    row_classes(item) {
      return item.rowcolor.toLowerCase();
    },
    sumSubField(key, subject) {
      // sum data in give key (property)
      const subjectgroup = this.listingData.filter(
        (item) => item.suB_NAME === subject
      );
      return subjectgroup.reduce((a, b) => a + (b[key] || 0), 0);
    },
    sumMnthField(key, mname) {
      // sum data in give key (property)
      const subjectgroup = this.listingData.filter(
        (item) => item.monthNo === mname
      );
      return subjectgroup.reduce((a, b) => a + (b[key] || 0), 0);
    },
    sumTotal(key) {
      // sum data in give key (property)
      const subjectgroup = this.listingData;
      return subjectgroup.reduce((a, b) => a + (b[key] || 0), 0);
    },
    toggleAll() {
      if (this.isExpanded) this.closeAll();
      else this.openAll();
    },
    closeAll() {
      this.isExpanded = false;
      Object.keys(this.$refs).forEach((k) => {
        if (this.$refs[k] && this.$refs[k].$attrs["data-open"]) {
          this.$refs[k].$el.click();
        }
      });
    },
    openAll() {
      this.isExpanded = true;
      Object.keys(this.$refs).forEach((k) => {
        if (this.$refs[k] && !this.$refs[k].$attrs["data-open"]) {
          this.$refs[k].$el.click();
        }
      });
    },
    closeAllFirst() {
      this.closeAll();
    },
    setChange(){
      this.closeAll();
      
    },
  },
  beforeDestroy() {
    this.fromDashboard = null;
  },
};
</script>
